import { render, staticRenderFns } from "./WBtnIcon.vue?vue&type=template&id=53348834&scoped=true&"
import script from "./WBtnIcon.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnIcon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53348834",
  null
  
)

export default component.exports